import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import space from "../../Assets/Projects/space.png";
import corrent from "../../Assets/Projects/corrent.png";
import hahucloud from "../../Assets/Projects/hahucloud.png";
import hoobank from "../../Assets/Projects/HOOBANK.png";
import afro from "../../Assets/Projects/afro.png";
import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Bits-0f-C0de"
              description="My personal blog page build with Next.js and Tailwind Css which takes the content from makdown files and renders it using Next.js. Supports dark mode and easy to write blogs using markdown."
              ghLink="https://github.com/pinocchio-life-like/eliyas_blog"
              demoLink="https://eliyasblog.vercel.app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={afro}
              isBlog={false}
              title="Lvi Hair Salon"
              description="Feel the most authentic you with a personalized haircut and barbering experience. Our stylists educate you on your hair with special attention to your hair type and needs, while following the latest trends."
              ghLink="https://github.com/pinocchio-life-like/afro_salon"
              demoLink="https://lvi-salon.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={corrent}
              isBlog={false}
              title="Corrent"
              description="Rent your Dream Car Around the World. We provide the best car options, with premium customer services at a competitive price. Car Type. eg. Sport."
              ghLink="https://github.com/pinocchio-life-like/Corrent-website"
              demoLink="https://corrent.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hoobank}
              isBlog={false}
              title="HooBank"
              description="HooBank is a futuristic bank. This project was created as a way to experiment with modern web development technologies, including the use of a UI library to speed up development."
              ghLink="https://github.com/pinocchio-life-like/Hoo_Bank"
              demoLink="https://eliyas-hoobank-landing.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hahucloud}
              isBlog={false}
              title="Hahu Cloud"
              description="We are using top servers for providing web hosting services in Ethiopia. Different hosting plans are available depending on the needs and requirements of yours."
              ghLink="https://github.com/pinocchio-life-like/hahu_cloud"
              demoLink="https://hahu-cloud-eliyas.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={space}
              isBlog={false}
              title="Space Tourism"
              description="Let's face it; if you want to go to space, you might as well genuinely go to outer space and not hover kind of on the edge of it. Well sit back, and relax because we'll give you a truly out of this world experiance"
              ghLink="https://github.com/pinocchio-life-like/space_tourism_website"
              demoLink="https://space-tourism-eliyas.netlify.app"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
